// Typelizer digest 68faa1c2d76916d265b37b29244236a1
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** PATCH /account_name */
  update: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/account_name', {}, options),
    method: 'patch',
  }),
}
